<template>
     <div class="parther-search">
          <PageTitle icon="fa fa-clone" main="Record" sub="Business Parther" />
            <b-form v-show="mode === 'save' || mode === 'remove' || mode === 'read'" >
             <input id="parther-id" type="hidden" v-model="parther.id" />
             <b-row>
                <b-col md="5" sm="12">
                    <b-form-group 
                        label="Name:" 
                        label-for="parther-name_parther">
                        <b-form-input 
                            id="parther-name_parther" 
                            type="text" 
                            ref="searchFocus"
                            v-model="parther.name_parther" 
                            required
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="Name..." />
                    </b-form-group>
                </b-col>   
                <b-col md="3" sm="12">
                    <b-form-group 
                        label="ID:" 
                        label-for="parther-doc_identification_parther">    
                        <b-form-input
                            id="parther-doc_identification_parther" 
                            type="text"
                            v-model="parther.doc_identification_parther" 
                            required
                            size="sm"
                            :readonly="true"
                            placeholder="ID..." />  
                    </b-form-group>
                </b-col>
                <b-col md="1" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="parther.blocked_parther" 
                                true-value="1" false-value="0" 
                                type="checkbox" 
                                id="parther-blocked_parther"
                                :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" for="parther-blocked_parther">
                                Blocked?
                            </label>
                        </div>
                    </div>
                </b-col>  
              
             </b-row>
            <b-card class="owner-search-card">
                    <b-tabs card >
                        <b-tab title="Complementary" active>
                        <b-form>
                             <b-row>
                                <b-col md="6" sm="12">
                                    <b-form-group
                                        label="Gender:"
                                        label-for="parther-gender_parther"
                                    >
                                        <b-form-select
                                            id="parther-gender_parther"
                                            size="sm"
                                            :options="genderparthers"
                                            :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                            v-model="parther.gender_parther"
                                        />
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                 <b-col md="2" sm="12">
                                    <b-form-group
                                    label="Birth Date:"
                                    label-for="parther-birth_date_parther"
                                    >
                                    <b-form-input
                                    id="parther-birth_date_parther"
                                    type="date"
                                    v-model="parther.birth_date_parther"
                                    :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                    size="sm"
                                    />
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-form>
                    </b-tab >
                    <b-tab title="Contact">
                        <b-form>
                            <b-row>
                                 <b-col md="6" sm="12">
                                    <b-form-group 
                                        label="E-mail:" 
                                        label-for="parther-email_parther">
                                        <b-form-input 
                                        id="parther-email" 
                                        type="email"
                                        v-model="parther.email_parther" 
                                        size="sm"
                                        :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                        placeholder="E-mail" />
                                    </b-form-group>
                                </b-col>
                                <b-col md="3" sm="12">
                                    <b-form-group 
                                        label="Phone number:" 
                                        label-for="parther-cellphone_parther">
                                        <b-form-input 
                                            id="parther-cellphone_parther" 
                                            type="text"
                                            v-model="parther.cellphone_parther" 
                                            size="sm"
                                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                            placeholder="Phone number" />
                                    </b-form-group>
                                </b-col>
                               
                            </b-row>   
                        </b-form>
                        </b-tab>
                        <b-tab title="Business Opportunity"> 
                        <b-row>
                        <transition  name="slide" type="animation" appear>       
                        <b-table 
                            class="table-responsive" 
                            hover 
                            key="slide"  
                            head-variant="light" 
                            :items="partheropportunitys" 
                            :fields="fieldOpportunity">
                            <template v-slot:cell(actions)="data">
                                <b-button 
                                    title="Reference Letter" 
                                    size="sm" 
                                    variant="light" 
                                    @click="[printerReferenceLetter(data.item)]" 
                                    class="mr-2 mt-2">
                                    <i class="fa fa-file-pdf-o"></i>
                                </b-button>
                            </template>
                        </b-table>
                        </transition>  
                        </b-row>
                        
                        </b-tab>
                    </b-tabs>
                </b-card>
        <br>
         </b-form>

            <hr v-show="mode === 'save'">
              <b-row>
                <b-col xs="12">
                   <b-button  
                        size="sm" 
                        variant="light" 
                        title="Add"
                        class="mt-2  mb-2 fa fa-plus" 
                        v-show="mode !== 'save' && mode !== 'remove'"
                        @click="alterModo">
                    </b-button>
                    <b-button 
                        size="sm" 
                        variant="light"
                         title="Save"
                        class="mt-2 mb-2 ml-2 fa fa-save" 
                        v-if="mode === 'save'"
                        @click="save">
                        </b-button>
                    <b-button 
                        size="sm" 
                        variant="light" 
                         title="Delete"
                        class="mt-2 mb-2 ml-2 fa fa-trash" 
                        v-if="mode === 'remove'"
                        @click="remove">
                    </b-button>
                    <b-button 
                        size="sm" 
                        btn-sm 
                        variant="light" 
                         title="Back"
                        class="mt-2 mb-2 ml-2 fa fa-mail-reply"  
                        v-if="mode === 'remove' || mode === 'save' || mode === 'read' "
                        @click="reset">
                    </b-button>
                    <b-button 
                         size="sm" 
                         class="mt-2 mb-2 ml-2 fa" 
                          title="Search"
                         :class="icon" 
                         @click="[loadTenants(),toggleBusy(),showTable = !showTable]" 
                         variant="light" >
                    </b-button>
                </b-col>
            </b-row>
            <br>
            <b-row v-show="mode !== 'save' && mode !== 'remove'">
                   <div class="col-sm-4">
                    <div class="form-group">
                        <input 
                            type="text" 
                            size="sm" 
                            icon="search" 
                            v-model="search" 
                            v-show="mode !== 'save' && mode !== 'remove'"
                            placeholder="Search by parther name" 
                            class="form-control">
                    </div>
                </div>  
          <transition  name="slide" type="animation" appear>       
            <b-table 
                 :busy="isBusy"  
                class="table-responsive" 
                :per-page="perPage" 
                :current-page="currentPage" 
                hover 
                 head-variant="dark" 
                v-show="showTable"
                :items="filteredList" 
                :fields="fields">
                <template v-slot:table-busy>
                    <div class="text-center text-info my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                </template>
               <template v-slot:cell(actions)="data">
                    <b-button
                        v-if="!data.item.user_parther_id >0"  
                        title = "Create Login" 
                        size="sm" 
                        variant="light" 
                        @click="showMsgBoxCreateUser(data.item)" 
                        class="mr-2 mt-2">
                        <i class="fa fa-user-circle"></i>
                    </b-button>
                    <b-button  
                        title = "View" 
                        size="sm" 
                        variant="light" 
                        @click="loadTenant(data.item, 'read')" 
                        class="mr-2 mt-2">
                        <i class="fa fa-drivers-license-o"></i>
                    </b-button>
                    <b-button  
                        title = "Edit" 
                        size="sm" 
                        variant="light" 
                        @click="loadTenant(data.item)" 
                        class="mr-2 mt-2">
                        <i class="fa fa-pencil"></i>
                    </b-button>
                     <b-button  
                        title = "Delete" 
                        size="sm" 
                        variant="light" 
                        @click="loadTenant(data.item, 'remove')" class="mr-2 mt-2">
                        <i class="fa fa-trash"></i>
                    </b-button>
                    <b-button
                        title="View File"
                        size="sm"
                        variant="light"
                        v-if="data.item.storage_id_passport_parther > 0"
                        @click="loadUrl(data.item)"
                        class="mr-2 mt-2"
                    >
                    <i class="fa fa-file-pdf-o"></i>
                    </b-button>
                </template>    
         </b-table> 
          </transition>
          <transition  name="slide" type="animation" appear>
            <b-pagination
                v-show="showTable"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                size="sm"
                aria-controls="my-table"
            ></b-pagination>
          </transition>
    </b-row>
     <b-modal
            id="modalOpportunity"
            ref="modal"
            title-tag="h6"
            title="Opportunity"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveOpportunity"
        >
            <b-form>
                <b-row>
                      <b-col md="2" sm="12">
                            <b-form-group
                            label="Opportunity Date:"
                            label-for="partheropportunity-agreement_date"
                            >
                            <b-form-input
                            id="partheropportunity-agreement_date"
                            type="date"
                            v-model="partheropportunity.agreement_date"
                            size="sm"
                            />
                            </b-form-group>
                        </b-col>
                </b-row>
                <b-row>
                    <b-col md="12" sm="12">
                        <b-form-group
                            label="Opportunity Name:"
                            label-for="partheropportunity-bank_name_parther"
                        >
                            <b-form-input
                                id="partheropportunity-bank_name_parther"
                                v-model="partheropportunity.bank_name_parther"
                                type="text"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                     <b-col md="6" sm="12">
                        <b-form-group
                            label="BCI:"
                            label-for="partheropportunity-bic_parther_bank"
                        >
                            <b-form-input
                                id="partheropportunity-bic_parther_bank"
                                v-model="partheropportunity.bic_parther_bank"
                                type="text"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="6" sm="12">
                        <b-form-group
                            label="IBAN:"
                            label-for="partheropportunity-iban_parther_bank"
                        >
                            <b-form-input
                                id="partheropportunity-iban_parther_bank"
                                v-model="partheropportunity.iban_parther_bank"
                                type="text"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                <b-col md="1" sm="12">
                    <div class="form-group">
                    <div class="form-check">
                        <input class="form-check-input" 
                            v-model="partheropportunity.favorite_parther_bank" 
                            true-value="1" false-value="0" 
                            type="checkbox" 
                            id="partheropportunity-favorite_parther_bank"
                        >
                        <label 
                            class="form-check-label" 
                            for="partheropportunity-favorite_parther_bank">
                            Favorite?
                        </label>
                    </div>
                    </div>
                </b-col>  
            
                </b-row>
            </b-form>
        </b-modal>
         <b-modal
            id="modalImmobile"
            ref="modal"
            title-tag="h6"
            title="Immobile"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveImmobile"
        >
          <b-form>
                <b-row>
                    <b-col md="12" sm="12">
                    <b-form-group 
                            label="Address:" 
                            label-for="immobile-address_immobile">
                        <b-form-input id="immobile-address_immobile" 
                            type="text"
                            v-model="immobile.address_immobile" 
                            size="sm"
                            placeholder="Address..." />
                    </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12" sm="12">
                    <b-form-group 
                            label="Region:" 
                            label-for="immobile-region_immobile">
                        <b-form-input id="immobile-region_immobile" 
                            type="text"
                            v-model="immobile.region_immobile" 
                            size="sm"
                            placeholder="Region..." />
                    </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="6" sm="12">
                        <b-form-group
                            label="Type:"
                            label-for="immobile-type_immobile_id_immobile"
                        >
                            <b-form-select
                                id="immobile-type_immobile_id_immobile"
                                size="sm"
                                :options="genderparthers"
                                v-model="immobile.type_immobile_id_immobile"
                            />
                        </b-form-group>
                    </b-col>
                <b-col md="4" sm="12">
                    <b-form-group
                        label="Maximum Tenant:"
                        label-for="immobile-maximum_number_parther_immobile"
                    >
                        <b-form-input
                            id="immobile-maximum_number_parther_immobile"
                            type="number"
                            v-model="immobile.maximum_number_parther_immobile"
                            size="sm"
                        />
                    </b-form-group>
                </b-col>
                </b-row>
                <b-row>
                    <b-col md="2" sm="12">
                        <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="immobile.active_immobile" 
                                true-value="1" false-value="0" 
                                type="checkbox" 
                                id="immobile-active_immobile"
                            >
                            <label 
                                class="form-check-label" 
                                for="immobile-active_immobile">
                                Active?
                            </label>
                        </div>
                        </div>
                    </b-col>  
                     <b-col md="2" sm="12">
                        <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="immobile.blocked_immobile" 
                                true-value="1" false-value="0" 
                                type="checkbox" 
                                id="immobile-blocked_immobile"
                            >
                            <label 
                                class="form-check-label" 
                                for="immobile-blocked_immobile">
                                Blocked?
                            </label>
                        </div>
                        </div>
                    </b-col>  
                </b-row>
          </b-form>
        </b-modal>
        <b-modal
         id="modalFile"
            ref="modal"
            title-tag="h6"
            size="lg"
            title="File"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="save"
      >
        <b-form>
          <b-row>
            <b-col md="12" sm="12">
              <b-form-file
                accept=".pdf"
                v-model="file"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
                @input="saveImagem"
                size="sm"
              ></b-form-file>
            </b-col>
          </b-row>
        </b-form>
      </b-modal>  
            
     </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'

var moment = require('moment-timezone')

export default {
    name: 'PartherSearch',
    components: {PageTitle },
    data: function() {
        return {
                mode: 'insert',
                search: '',
                file:null,
                parther: {},
                partheropportunity: {},
                immobile: {},
                partheropportunitys:[],
                immobiles:[],
                parthers: [],
                genderparthers: [],
                perPage: 50,
                currentPage: 1,
                isBusy: false,
                showTable: false,
                headerBgVariant: 'dark',
                headerTextVariant: 'light',
                bodyBgVariant: 'light',
                bodyTextVariant: 'dark',
                footerBgVariant: 'warning',
                footerTextVariant: 'dark',
                fields: [
                { key: 'name_parther', label: 'Name', sortable: true,variant: 'light' },
                { key: 'doc_identification_parther', label: 'ID', sortable: true ,variant: 'light'},
                { key: 'email_parther', label: 'E-mail', sortable: false ,variant: 'light'},   
                { key: 'cellphone_parther', label: 'Phone Number', sortable: false ,variant: 'light'},   
                { key: 'blocked', label: 'Blocked', sortable: false,
                        formatter: value => value ? 'Yes' : 'No' ,variant: 'light'},               
                { key: 'actions', label: 'Action',variant: 'light' },
                //{ key: 'accesses', label: 'Acessos',variant: 'secondary' }
                ],
                fieldOpportunity: [
                {
                    key: 'date_opportunity',label: 'Opportunity Date',sortable: true,
                        formatter: value =>
                        value ? moment.utc(value).format('DD-MM-YYYY') : ''
                },
                { key: 'description_opportunity', label: 'Description', sortable: true },
                { key: 'address_immobile', label: 'Address', sortable: true },
                { key: 'region_immobile', label: 'Region', sortable: true },
                { key: 'name_type_mmobile', label: 'Type', sortable: true },
                {
                    key: 'value_opportunity',
                    label: 'Value Opportunity',
                    sortable: false,
                    variant: 'secondary',
                    formatter: value => (value ? this.formatPrice(value) : 0)
                },
                {
                    key: 'value_closed_opportunity',
                    label: 'Closing Value',
                    sortable: false,
                    variant: 'secondary',
                    formatter: value => (value ? this.formatPrice(value) : 0)
                },
                {
                    key: 'percent_opportunity',
                    label: 'Perc. Value',
                    sortable: false,
                    variant: 'secondary',
                    formatter: value => (value ? this.formatPrice(value) : 0)
                },
                {
                  key: 'date_closed_opportunity',label: 'Closing Date',sortable: true,
                        formatter: value =>
                        value ? moment.utc(value).format('DD-MM-YYYY') : ''
                },
                { key: 'actions', label: 'Action',variant: 'light' }
                ]
            }
        },
        computed: {
            filteredList() {
                return this.parthers.filter(parther => {
                    return parther.name_parther.toLowerCase().includes(this.search.toLowerCase())
                    })
            },
            compan(){
                return this.$store.state.compan
            },
            icon() {
            return this.showTable ? "fa-retweet" : "fa-search";
            },
            rows() {
                return this.parthers.length
            },
            user(){
                    return this.$store.state.user
            },
        },
        methods:{
            formatDate(date) {
                return moment(date)
                    .format('YYYY-MM-DD')
                    
            },
            formatDateTime(date) {
                return moment(date)
                    .format('YYYY-MM-DD LT')
            },
            formatPrice(value) {
                let val = (value / 1).toFixed(2).replace('.', ',')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
            },
            toggleBusy() {
                this.isBusy = !this.isBusy
            },
               async showMsgBoxCreateUser(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to create login?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.createUserParther(item)
                    }
                })
            },
            async showMsgBoxDeleteOpportunity(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to delete the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.removeOpportunity(item)
                    }
                })
            },
             async showMsgBoxDeleteImmobile() {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to delete the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.removeImmobile()
                    }
                })
            },
            loadTenants(){
                const url = `${baseApiUrl}/parthersbycompany/${this.compan.id}`
                axios(url).then(res =>{
                     this.parthers = res.data
                      this.isBusy = false
                })
            },
            loadTenantOpportunitys(){
                const url = `${baseApiUrl}/partheropportunitybyparther/${this.parther.id}`
                axios(url).then(res =>{
                     this.partheropportunitys = res.data
                })
            },
            loadTenantImmobiles(){
                const url = `${baseApiUrl}/partheropportunitybyparther/${this.parther.id}`
                axios(url).then(res =>{
                     this.immobiles = res.data
                })
            },
            alterModo() {
                    this.mode = 'save'
                    this.parther = {}
                    this.partheropportunity = {}
                    this.immobile = {}
                    this.partheropportunitys = []
                    this.immobiles = []
                    this.$refs.searchFocus.focus();
            },
             reset() {
                this.mode = 'insert'
                this.loadTenants()
                this.partheropportunitys = []
                this.immobiles = []
                this.parther = {}
            },
            async save() {

                const method = this.parther.id ? 'put' : 'post'
                const id = this.parther.id ? `/${this.parther.id}` : ''

                if(this.parther.id){
                    this.parther.update_date_parther = this.formatDateTime(Date())
                    this.parther.update_user_id_parther = this.user.id
                }else{
                    this.parther.user_id_parther = this.user.id
                    this.parther.company_id_parther = this.compan.id
                }

                await axios[method](`${baseApiUrl}/parthers${id}`, this.parther)
                    .then(async () => {
                        this.$toasted.global.defaultSuccess()
                        await this.createEntity(this.parther)
                        this.reset()
                    })
                    .catch(showError)
            },
            async createEntity(item){
                 await axios['post'](`${baseApiUrl}/partherscreateentity`, item)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()

                    })
                    .catch(showError)
            },
            async saveOpportunity() {
                    if (this.partheropportunity.id) {
                        this.partheropportunity.update_user_parther_bank = this.user.id
                        this.partheropportunity.update_date_parther_bank = this.formatDateTime(Date())
                    } else {
                        this.partheropportunity.user_id_parther_bank = this.user.id
                    }

                    const method = this.partheropportunity.id ? 'put' : 'post'
                    const id = this.partheropportunity.id ? `/${this.partheropportunity.id}` : ''
                    this.partheropportunity.parther_bank_id = this.parther.id
                    await axios[method](
                        `${baseApiUrl}/partheropportunitys${id}`,
                        this.partheropportunity
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.partheropportunity = {}
                            this.loadTenantOpportunitys()
                        })
                        .catch(showError)
            },
            async saveImmobile() {

                    if (this.immobile.id) {
                        this.immobile.update_user_immobile = this.user.id
                        this.immobile.update_date_immobile = this.formatDateTime(Date())
                    } else {
                        this.immobile.user_id_immobile = this.user.id
                    }

                    const method = this.immobile.id ? 'put' : 'post'
                    const id = this.immobile.id ? `/${this.immobile.id}` : ''
                    this.immobile.parther_id_immobile = this.parther.id
                    await axios[method](
                        `${baseApiUrl}/immobiles${id}`,
                        this.immobile
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.immobile = {}
                            this.loadTenantImmobiles()
                        })
                        .catch(showError)
            },
            remove() {
                    const id = this.parther.id
                    axios.delete(`${baseApiUrl}/parthers/${id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.reset()
                        })
                        .catch(showError)
            },
           async removeOpportunity(item) {
 
                    axios.delete(`${baseApiUrl}/partheropportunitys/${item.id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadTenantOpportunitys()
                        })
                        .catch(showError)
            },
           async removeImmobile() {
                    const id = this.parther.id
                    axios.delete(`${baseApiUrl}/immobiles/${id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadTenantImmobiles()
                        })
                        .catch(showError)
            },

            loadTenant(parther, mode = 'save') {
                this.mode = mode

                  if (parther.birth_date_parther)
                parther.birth_date_parther = this.formatDate(
                    parther.birth_date_parther
                )

                this.parther = { ...parther }
                this.$refs.searchFocus.focus();
                this.loadTenantOpportunitys()
                this.loadTenantImmobiles()
            },
            loadTenantOpportunity(item){
                this.partheropportunity = {...item}
            },
            loadTenantImmobile(item){
                this.immobile = {...item}
            },
            loadGenderTenant() {
                const url = `${baseApiUrl}/gendertenants`
                axios.get(url).then(res => {
                    this.genderparthers = res.data.map(type => {
                        return { value: type.id, text: type.name_gender_tenant }
                    })
                })
            },
            async printerReferenceLetter(item) {
    
            const url = `${baseApiUrl}/partherreferenceletterprinter/${item.id}`
            await axios.get(url)
            window.open(url)
            
            },
            setPassport(parther){
                 this.parther = { ...parther }
            },
              async saveImagem() {
                let formData = new FormData();
                formData.append("file", this.file);

                await axios
                    .post(`${baseApiUrl}/storagefiles`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    })
                    .then(() => {
                    this.$toasted.global.defaultSuccess();
                    this.getLastStorageFile();
                    })
                    .catch(showError);
                },
                async getLastStorageFile() {
                const url = `${baseApiUrl}/storagefilesbylast/?name_file=${this.file.name}`;
                    await axios(url).then(
                        (res) =>
                        (this.parther = {
                            ...this.parther,
                            storage_id_passport_parther: res.data.id,
                        })
                    );
                },  
                loadUrl(item){
                    window.open(item.url_file)
                }, 
                async createUserParther(item){

                        this.parther = {...item}
                       if (!item.email_parther) {
                            this.$toasted.global.defaultError({ msg: 'Email not provided when registering..' })
                        }
                        if (!item.birth_date_parther) {
                            this.$toasted.global.defaultError({ msg: 'Date of birth not specified in registration...' })
                        }

                        let user_parther = {}

                        user_parther = {

                            name: item.name_parther,
                            email: item.email_parther,
                            company_default_id: this.compan.id,
                            blocked: 0,
                            parther:1,
                            password: moment(item.birth_date_parther).format('YYYY'),
                            confirmPassword: moment(item.birth_date_parther).format('YYYY')
                        }

                         axios.post(`${baseApiUrl}/signup`, user_parther)
                            .then(() => {
                                this.$toasted.global.defaultSuccess()
                                this.getLastUserParther()
                            })
                            .catch(showError)
                },
                async getLastUserParther() {
                const url = `${baseApiUrl}/partherbyuserid/${this.compan.id}/?name=${this.parther.name_parther}&email=${this.parther.email_parther}`;
                    await axios(url).then(
                        (res) =>
                        (this.parther = {
                            ...this.parther,
                            user_parther_id: res.data.id,
                        })
                    );

                    if(this.parther.parther_user_id_parther > 0){
                        this.save()
                    }
                },  

        },
        mounted(){
            this.loadTenants()
            this.loadGenderTenant()
            this.showTable = true
        }
}
</script>

<style>


    .parther-search{
        font-size: 0.75rem;
        color: white;
   
    }

    .parther-search button{
        font-size: 0.75rem;
    }

     .parther-search select{
        font-size: 0.75rem;
    }

    .parther-search input{
        font-size: 0.75rem;
    }


    .parther-search-card label{
        font-size: 0.75rem;
        color: black;
   
    }


    #modalOpportunity {
        font-size: 0.75rem;
    }

    #modalOpportunity button{
        font-size: 0.75rem;
    }

     #modalOpportunity input{
        font-size: 0.75rem;
    }

      #modalOpportunity label{
        font-size: 0.75rem;
        color: black;
    }

     #modalImmobile {
        font-size: 0.75rem;
    }

    #modalImmobile button{
        font-size: 0.75rem;
    }

     #modalImmobile input{
        font-size: 0.75rem;
    }

      #modalImmobile select{
        font-size: 0.75rem;
    }

      #modalImmobile label{
        font-size: 0.75rem;
        color: black;
    }

    #modalFile {
    font-size: 0.75rem;
    }

    #modalFile button{
    font-size: 0.75rem;
    }



    
@keyframes slide-in {
  from {
    transform: translateY(40px);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(40px);
  }
}

.slide-enter-active {
  animation: slide-in 1s ease;
  transition: opacity 1s;
}

.slide-leave-active {
  animation: slide-out 1s ease;
  transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

</style>
